// GERADO por apps/api/src/test/module-tool-roles-parity.test.ts. Não editar à mão.
// Papéis que o servidor aceita para confirmar cada ferramenta de escrita (política do módulo).
export const MODULE_TOOL_ROLES: Record<string, readonly string[]> = {
  "conciliacao.cancel-file": ["admin","owner"],
  "conciliacao.change": ["admin","owner"],
  "conciliacao.file-choices": ["admin","owner"],
  "conciliacao.financial-adjustment": ["admin","owner"],
  "conciliacao.import-file": ["admin","owner"],
  "conciliacao.record-balance": ["admin","owner"],
  "escalas.absence-cancel": ["admin","manager","owner"],
  "escalas.absence-register": ["admin","manager","owner"],
  "escalas.availability-set": ["accountant","admin","agent","delivery","editor","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "escalas.coverage-set": ["admin","manager","owner"],
  "escalas.plan-create": ["admin","manager","owner"],
  "escalas.schedule-publish": ["admin","manager","owner"],
  "escalas.schedule-revise": ["admin","manager","owner"],
  "escalas.shift-cancel": ["admin","manager","owner"],
  "escalas.shift-create": ["admin","manager","owner"],
  "escalas.shift-remove-draft": ["admin","manager","owner"],
  "escalas.shift-update": ["admin","manager","owner"],
  "escalas.swap-approve": ["admin","manager","owner"],
  "escalas.swap-cancel": ["accountant","admin","agent","delivery","editor","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "escalas.swap-reject": ["admin","manager","owner"],
  "escalas.swap-request": ["accountant","admin","agent","delivery","editor","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "estoque.batch-adjust": ["admin","owner"],
  "estoque.conditional-return": ["admin","owner","sales_inventory"],
  "estoque.conditional-send": ["admin","owner","sales_inventory"],
  "estoque.count": ["admin","owner"],
  "estoque.count-request": ["admin","inventory","owner","sales_inventory"],
  "estoque.count-review": ["admin","manager","owner"],
  "estoque.loss-request": ["admin","inventory","owner"],
  "estoque.loss-review": ["admin","manager","owner"],
  "estoque.lot-enable": ["admin","owner"],
  "estoque.move": ["admin","owner","sales_inventory"],
  "estoque.opening-count": ["admin","owner"],
  "estoque.opening-order": ["admin","owner"],
  "estoque.opening-order-resolve": ["admin","owner"],
  "estoque.policy": ["admin","owner"],
  "estoque.reservation-consume": ["admin","owner"],
  "estoque.reservation-create": ["admin","owner"],
  "estoque.reservation-release": ["admin","owner"],
  "estoque.return-quarantine": ["admin","owner"],
  "estoque.transfer": ["admin","owner","sales_inventory"],
  "estoque.transfer-receive": ["admin","owner","sales_inventory"],
  "estoque.ui-restore": ["admin","owner"],
  "estoque.ui-save": ["admin","owner"],
  "fidelidade.adjustment": ["admin","owner"],
  "fidelidade.earn": ["admin","owner"],
  "fidelidade.membership-enroll": ["admin","manager","owner","sales","sales_inventory"],
  "fidelidade.membership-leave": ["admin","manager","owner","sales","sales_inventory"],
  "fidelidade.program-create": ["admin","owner"],
  "fidelidade.program-pause": ["admin","owner"],
  "fidelidade.redemption-cancel": ["admin","manager","owner","sales","sales_inventory"],
  "fidelidade.redemption-confirm": ["admin","manager","owner","sales","sales_inventory"],
  "fidelidade.redemption-prepare": ["admin","manager","owner","sales","sales_inventory"],
  "fidelidade.reverse": ["admin","owner"],
  "fidelidade.version-publish": ["admin","owner"],
  "formularios.archive": ["admin","owner"],
  "formularios.collection-close": ["admin","owner"],
  "formularios.collection-open": ["admin","owner"],
  "formularios.conversion-contact": ["admin","owner"],
  "formularios.conversion-opportunity": ["admin","owner"],
  "formularios.conversion-request": ["admin","owner"],
  "formularios.create": ["admin","owner"],
  "formularios.pause": ["admin","owner"],
  "formularios.publish": ["admin","owner"],
  "formularios.submission-annotate": ["admin","owner"],
  "formularios.submission-discard": ["admin","owner"],
  "formularios.submission-reopen": ["admin","owner"],
  "formularios.update": ["admin","owner"],
  "locacao.account-default-set": ["admin","manager","owner"],
  "locacao.booking-cancel": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.booking-change": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.booking-confirm": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.deposit-release-prepare": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.extra-charge-prepare": ["admin","manager","owner"],
  "locacao.handover-register": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.inspection-complete": ["admin","manager","owner"],
  "locacao.quote-create": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "locacao.resource-configure": ["admin","manager","owner"],
  "locacao.return-register": ["admin","delivery","inventory","manager","owner","sales","sales_inventory"],
  "loja.enable": ["admin","editor","owner"],
  "loja.media-migration-apply": ["admin","owner"],
  "loja.media-migration-prepare": ["admin","owner"],
  "loja.media-migration-rollback": ["admin","owner"],
  "loja.presentation-patch": ["admin","editor","owner"],
  "loja.presentation-restore": ["admin","editor","owner"],
  "loja.preview": ["admin","editor","owner"],
  "loja.publish-product": ["admin","editor","owner"],
  "loja.save": ["admin","editor","owner"],
  "loja.ui-restore": ["admin","editor","owner"],
  "loja.ui-save": ["admin","editor","owner"],
  "orcamento.allocation-apply": ["admin","finance","owner"],
  "orcamento.allocation-propose": ["admin","finance","owner"],
  "orcamento.allocation-reverse": ["admin","finance","owner"],
  "orcamento.budget-approve": ["admin","owner"],
  "orcamento.budget-close": ["admin","finance","owner"],
  "orcamento.budget-create": ["admin","finance","owner"],
  "orcamento.budget-revise": ["admin","finance","owner"],
  "orcamento.budget-submit": ["admin","finance","owner"],
  "orcamento.budget-transfer": ["admin","finance","owner"],
  "orcamento.center-archive": ["admin","finance","owner"],
  "orcamento.center-create": ["admin","finance","owner"],
  "orcamento.center-update": ["admin","finance","owner"],
  "orcamento.rule-define": ["admin","finance","owner"],
  "patrimonio.asset-assign": ["admin","owner"],
  "patrimonio.asset-create": ["admin","owner"],
  "patrimonio.asset-receive": ["admin","delivery","inventory","manager","owner","sales","sales_inventory","technician"],
  "patrimonio.asset-release": ["admin","owner"],
  "patrimonio.asset-retire": ["admin","owner"],
  "patrimonio.asset-return": ["admin","delivery","inventory","manager","owner","sales","sales_inventory","technician"],
  "patrimonio.asset-transfer": ["admin","delivery","inventory","manager","owner","sales","sales_inventory","technician"],
  "patrimonio.asset-update": ["admin","owner"],
  "patrimonio.expense-prepare": ["admin","owner"],
  "patrimonio.failure-register": ["admin","delivery","inventory","manager","owner","sales","sales_inventory","technician"],
  "patrimonio.meter-correct": ["admin","owner"],
  "patrimonio.meter-register": ["admin","delivery","inventory","manager","owner","sales","sales_inventory","technician"],
  "patrimonio.order-cancel": ["admin","owner","technician"],
  "patrimonio.order-complete": ["admin","owner","technician"],
  "patrimonio.order-generate": ["admin","owner","technician"],
  "patrimonio.order-start": ["admin","owner","technician"],
  "patrimonio.plan-create": ["admin","owner","technician"],
  "patrimonio.plan-pause": ["admin","owner","technician"],
  "patrimonio.plan-update": ["admin","owner","technician"],
  "patrimonio.stock-consumption-prepare": ["admin","owner","technician"],
  "reembolsos.claim-create": ["admin","agent","delivery","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "reembolsos.claim-submit": ["admin","agent","delivery","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "reembolsos.claim-update": ["admin","agent","delivery","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "reembolsos.claim-withdraw": ["admin","agent","delivery","finance","inventory","manager","owner","sales","sales_inventory","technician"],
  "reembolsos.expense-cancel": ["admin","finance","owner"],
  "reembolsos.line-review": ["admin","manager","owner"],
  "reembolsos.policy-set": ["owner"],
};
